import alt from 'framework/alt';

class CsrfActions {
  constructor() {
    this.generateActions(
      'refreshToken',
      'setToken',
    );
  }
}

export default alt.createActions(CsrfActions);
